module.exports = __webpack_public_path__ + "img/cloud-upload.09dcf0aa.svg";